var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E61F26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1918 8.90603C15.4061 8.69181 15.6968 8.57147 15.9998 8.57147C16.3028 8.57147 16.5935 8.69181 16.8078 8.90603L21.9508 14.049C22.1569 14.265 22.2703 14.553 22.2667 14.8515C22.2632 15.1499 22.1431 15.4352 21.932 15.6463C21.721 15.8573 21.4357 15.9775 21.1373 15.981C20.8388 15.9845 20.5508 15.8711 20.3348 15.665L17.1428 12.473V22.286C17.1428 22.5892 17.0224 22.8799 16.808 23.0942C16.5937 23.3086 16.303 23.429 15.9998 23.429C15.6967 23.429 15.4059 23.3086 15.1916 23.0942C14.9772 22.8799 14.8568 22.5892 14.8568 22.286V12.473L11.6648 15.665C11.5596 15.7753 11.4335 15.8634 11.2938 15.9241C11.1541 15.9849 11.0036 16.0171 10.8513 16.0189C10.6989 16.0207 10.5477 15.992 10.4066 15.9346C10.2655 15.8771 10.1373 15.792 10.0296 15.6842C9.92187 15.5765 9.83676 15.4483 9.77928 15.3072C9.7218 15.1661 9.69311 15.0149 9.6949 14.8626C9.69669 14.7102 9.72892 14.5598 9.7897 14.4201C9.85048 14.2804 9.93857 14.1542 10.0488 14.049L15.1918 8.90603Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.e3f39e7ce409ce75d9f11179a4523a92.svg";
export { ForwardRef as ReactComponent };